import { DateQueryBuilder } from './DateQueryBuilder';
import { DatetimeQueryBuilder } from './DatetimeQueryBuilder';
import { SearchQueryBuilder } from './SearchQueryBuilder';
import { IntegerQueryBuilder } from './IntegerQueryBuilder';
// import { ForeignKeyQueryBuilder } from './ForeignKeyQueryBuilder';
import { ExactMatchQueryBuilder } from './ExactMatchQueryBuilder';
import { TextQueryBuilder } from './TextQueryBuilder';
import { CaretDelimitedStringQueryBuilder } from './CaretDelimitedStringQueryBuilder';

export default class QueryBuilderFactory {

  constructor(queryType) {
    this.queryType = queryType;
  }

  /**
   * Generate a new instance of a query builder
   * @param {string} operator
   */
  generate(operator, query) {
    switch (this.queryType) {
      case 'keywords':
        return new SearchQueryBuilder(operator, query);

      case 'date':
        return new DatetimeQueryBuilder(operator, query);

      // The weird naming will exist here until a migration can be run to fix
      // the live filters.
      case 'date-only':
        return new DateQueryBuilder(operator, query);

      case 'integer':
        return new IntegerQueryBuilder(operator, query);

      case 'caret-delimited':
        return new CaretDelimitedStringQueryBuilder(operator, query);

      case 'hotness':
      case 'multiselect': // deprecated; renamed exact-match
      case 'exact-match': {
        const builder = new ExactMatchQueryBuilder(operator, query);
        builder.setEmptyValue('');
        return builder;
      }

      case 'text': {
        const builder = new TextQueryBuilder(operator, query);
        return builder;
      }

      case 'foreignkey':
        return new ExactMatchQueryBuilder(operator, query);

      default:
        return new Error(`${this.queryType} is not supported`);
    }
  }
}
